module.exports = __webpack_public_path__ + "img/check.3e13e2c9.png";